module.exports = __webpack_public_path__ + "static/1984-4-eec072482fa1a086271968263937de6b.png";